
import React from 'react';

interface AccordionCardProps {
  title: string;
  icon: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const AccordionCard: React.FC<AccordionCardProps> = ({ title, icon, isOpen, onClick, children }) => {
  return (
    <div className="border border-light-gray rounded-xl overflow-hidden transition-all duration-300 ease-in-out">
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50 focus:outline-none"
      >
        <div className="flex items-center gap-4">
          <div className="text-primary">{icon}</div>
          <span className="font-semibold text-gray-700">{title}</span>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-5 w-5 text-gray-500 transform transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <div
        className={`transition-all duration-500 ease-in-out overflow-hidden ${
          isOpen ? 'max-h-none pb-8' : 'max-h-0'
        }`}
      >
        <div className="p-0 bg-gray-50 border-t border-light-gray">{children}</div>
      </div>
    </div>
  );
};

export default AccordionCard;
